import { Component, OnInit } from '@angular/core';
import { KPIDashboardService, KPIDashboardStatsResponse } from '~lmo/kpidashboard/kpidashboard.service';

@Component({
  selector: 'sa-stats',
  styleUrls: ['./stats.component.scss'],
  templateUrl: './stats.component.html',
})
export class StatsComponent implements OnInit {
  public regionID: number;
  public fracsID: number[];
  public stats: KPIDashboardStatsResponse = this.initializeStats();

  constructor(private kpiDashboardService: KPIDashboardService) {}

  public ngOnInit(): void {
    this.kpiDashboardService.regionID$.subscribe((regionID) => {
      this.resetStats();
      this.regionID = regionID;
      this.fetchStats(regionID, []);
    });

    this.kpiDashboardService.fracsID$.subscribe((fracsID) => {
      if (fracsID.length > 0) {
        this.resetStats();
        this.fracsID = fracsID;
        this.fetchStats(this.regionID, this.fracsID);
      } else {
        this.resetStats();
        this.fetchStats(this.regionID, []);
      }
    });
  }

  private fetchStats(regionID: number, fracsID: number[]): void {
    this.kpiDashboardService.getStats$(regionID, fracsID).subscribe((data) => {
      this.stats = data;
    });
  }

  private resetStats(): void {
    this.stats = this.initializeStats();
  }

  private initializeStats(): KPIDashboardStatsResponse {
    return {
      completedLoads: { value: 0, trend: '', difference: 0 },
      inProgressLoads: { value: 0, trend: '', difference: 0 },
      ocrVerifiedLoads: { value: 0, trend: '', difference: 0 },
      pendingLoads: { value: 0, trend: '', difference: 0 },
      revenue: { value: 0, trend: '', difference: 0 },
    };
  }
}
